interface ActionCardProps {
  title: string;
  subtitle: string;
  header?: React.ReactNode;
  footer?: React.ReactNode;
  className?: string;
  ariaLabel?: string;
}

export function ActionCard({
  title,
  subtitle,
  header,
  footer,
  className = "",
  ariaLabel,
}: ActionCardProps) {
  return (
    <div
      aria-label={ariaLabel}
      className={`group block rounded-xl border border-border/60 bg-background/60 px-5 py-6 transition-colors hover:border-border text-left ${className}`}
    >
      {header}
      <div className="space-y-1">
        <div className="text-base sm:text-lg font-semibold tracking-tight text-foreground">
          {title}
        </div>
        <div className="text-xs sm:text-sm text-muted-foreground/80">
          {subtitle}
        </div>
      </div>
      {footer}
    </div>
  );
}
